import { Component, ElementRef, Input, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import { AsyncPipe, NgClass, NgIf } from "@angular/common";
import { DirectoryItemModel } from "../../advanced-search/directory-search/models/directory-item.model";
import { ExternalConfigurationService } from "../../../shared-library/services/configuration/external-configuration.service";
import { BookletService } from "../services/booklet.service";

@Component({
    selector: AddToBookletComponent.SELECTOR,
    templateUrl: "./add-to-booklet.component.html",
    styles: [],
    standalone: true,
    imports: [
        AsyncPipe,
        NgIf,
        NgClass
    ]
})
export class AddToBookletComponent implements OnInit {
    public static SELECTOR: string = "pcg-ng-add-to-booklet";

    @Input() public directoryItem: DirectoryItemModel;
    @Input() public directoryItemUrl: string;

    public className: string;

    protected isInBooklet$: Observable<{ is: boolean }>;

    public constructor(
        private configurationService: ExternalConfigurationService<DirectoryItemModel>,
        private domElement: ElementRef,
        private bookletService: BookletService
    ) {
    }

    public ngOnInit(): void {
        if (!this.directoryItem) {
            this.configurationService.initialize(this.domElement);
            this.directoryItem = this.configurationService.config;
            this.directoryItemUrl = window.location.href;

            const element = this.domElement.nativeElement as HTMLElement;
            this.className = element.getAttribute("data-class-name");
        }

        this.isInBooklet$ = this.bookletService.isInBooklet$(this.directoryItem.id).pipe();
    }

    public addToBooklet(e: Event): void {
        e.preventDefault();

        this.bookletService.addItem(this.directoryItem, this.directoryItemUrl);
    }

    public removeFromBooklet(e: Event): void {
        e.preventDefault();

        this.bookletService.removeItem(this.directoryItem.id);
    }
}
